import { createPatternComprehension, createTriggerConsumerEmitter } from './base';

export const comprehendDischargePermits = createTriggerConsumerEmitter({
   filterField: 'DischargePermitNumber',
   triggers: ['dp'],
   consume: token => /^\d{3,}$/.test(token),
   emit: token => [token, `DP-${token}`],
   notificationMessage: values =>
      `Interpreted "dp" and subsequent numbers as Discharge Permit Number filters: ${values.filter(t => t.startsWith('DP-')).join(', ')}.`,
});

export const comprehendDischargePermitPattern = createPatternComprehension({
   filterField: 'DischargePermitNumber',
   pattern: /^dp-?\d{3,}$/i,
   emit: (token) => {
      const digits = token.replace(/^dp-?/i, '');
      return [digits, `DP-${digits}`];
   },
   notificationMessage: values =>
      `Interpreted ${values.join(', ')} as Discharge Permit Number filters.`,
});
